import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import { useFetch } from '../../hooks/useFetch';
import { useEffect, useState } from 'react';
import {
  Container,
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  Divider,
  Card,
  Paper,
  CardActions,
  CardContent,
} from '@mui/material/';

import CircularProgress from '@mui/material/CircularProgress';
import SelectedStudent from '../SelectedStudent';

import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import QuoteTotalFooter from './QuoteTotalFooter';
import SelectedVenue from '../SelectedVenue';
import OrderTotal from './OrderTotal';
import CloseIcon from '@mui/icons-material/Close';
import { DataGrid } from '@mui/x-data-grid';

function ViewQuote({
  sessionId,
  academicYear,
  studentId,
  campusId,
  venueId,
  setViewExams,
  setViewTerms,
  setViewQuote,
  setViewOrder,
}) {
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const [tableData, setTableData] = useState([]);

  const {
    postData,
    error,
    isPending,
    data: quoteData,
  } = useFetch('https://pcapi.bi-oss.co.za/studcambridge/generatequote');

  useEffect(() => {
    if (studentId && campusId && venueId) {
      postData({
        studentId,
        campusId,
        sessionId,
        academicYear,
        updatedBy: user.email,
        venueId,
      });
    }
  }, [studentId, campusId, venueId]);

  useEffect(() => {
    if (quoteData) {
      setTableData(quoteData);
    }
  }, [quoteData]);

  const columns = [
    { field: 'academicYear', headerName: 'Year:', width: 100, editable: false },
    { field: 'session', headerName: 'Session:', width: 100, editable: false },

    { field: 'paperCode', headerName: 'Code:', width: 100, editable: false },
    {
      field: 'description',
      headerName: 'Paper Description:',
      width: 200,
      editable: false,
    },

    { field: 'efee', headerName: 'Exam Fee:', width: 130, editable: false },
    {
      field: 'invFee',
      headerName: 'Invigilation:',
      width: 130,
      editable: false,
    },

    {
      field: 'paperFee',
      headerName: 'Venue Fee:',
      width: 130,
      editable: false,
    },

    {
      field: 'penaltyFee',
      headerName: 'Penalty:',
      width: 130,
      editable: false,
    },

    {
      field: 'examTotal',
      headerName: 'Exam Total:',
      width: 200,
      editable: false,
    },
  ];

  const handleOnCellClick = (e) => {
    // window.open(e.row.fileURL, '_blank')
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setViewQuote(0);
    setViewOrder(1);
  };

  const handleChangeExams = (e) => {
    e.preventDefault();
    setViewExams(1);
    setViewTerms(0);
    setViewQuote(0);
  };

  return (
    <>
      {isPending && (
        <Container maxWidth="lg">
          <Box mb={5} />

          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
            sx={{
              border: 'solid',
              borderWidth: '3px',
              borderColor: 'primary.main',
              borderRadius: 2,
            }}
          >
            <Grid item xs={12}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
                <Typography variant="h6" component="h3" color="primary.main">
                  Generating quotation ........
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      )}

      {!isPending && (
        <Container maxWidth="lg">
          <Box mb={5} />

          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
            sx={{
              border: 'solid',
              borderWidth: '3px',
              borderColor: 'primary.main',
              borderRadius: 2,
            }}
          >
            <Grid item xs={12}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography
                  variant="h4"
                  component="h4"
                  color="primary.main"
                  sx={{ textAlign: 'center' }}
                >
                  Cambridge External Assessment Application Quote
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <SelectedStudent studentId={studentId} />
              </Box>
            </Grid>

            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <SelectedVenue venueId={venueId} />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography variant="body2" component="p" color="primary">
                  <b>Please Note: </b>

                  <ul>
                    <li>
                      The below quote is based on your selected venue, any venue
                      change requests will incur additional fees.
                    </li>
                    <li>
                      Only one venue per exam session may be used. The below
                      quote is based on your selected venue, any venue change
                      requests will incur additional fees.
                    </li>

                    <li>
                      Entries are only processed once online payment has been
                      completed.{' '}
                    </li>
                    <li>
                      No manual quotes or manual payments will be accepted.
                      Entries <b>must</b> be processed online. (Pricing subject
                      to change based on date of entry){' '}
                    </li>
                  </ul>
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography variant="h5" component="h5" color="primary">
                  Exam List
                </Typography>
              </Box>
            </Grid>

            {!isPending && !error && tableData && tableData.length === 0 && (
              <>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Typography variant="body2" component="p" color="primary">
                      <b>
                        There are currently no authorisation for the selected
                        student.
                      </b>
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <Button
                          fullWidth
                          variant="contained"
                          onClick={handleChangeExams}
                        >
                          Add Exams
                          <ChangeCircleIcon />
                        </Button>
                      </Box>
                    </Grid>
                  </Box>
                </Grid>
              </>
            )}
            {!isPending && !error && tableData && tableData.length > 0 && (
              <>
                <Grid item xs={12} minWidth={0}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <DataGrid
                      rows={tableData}
                      columns={columns}
                      sx={{
                        color: 'primary.main',
                        borderColor: 'primary.main',
                        borderWidth: 3,
                        fontWeight: 'bold',
                        m: 1,
                        align: 'center',
                        headerAlign: 'center',
                        autoCapitalize: 'words',
                      }}
                      disableRowSelectionOnClick={true}
                      disableColumnSelector={true}
                      hideFooterRowCount
                      hideFooterSelectedRowCount
                      hideFooterPagination
                      getRowId={(row) => row.id}
                      autoHeight
                      pageSize={(row) => row.length}
                      components={{
                        Footer: () => (
                          <QuoteTotalFooter
                            studentId={studentId}
                            campusId={campusId}
                            sessionId={sessionId}
                            academicYear={academicYear}
                          />
                        ),
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Typography variant="body2" component="p" color="primary">
                      If you would like to add or change your examination
                      selection, click on Change Selection.
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <Button
                          fullWidth
                          variant="contained"
                          onClick={handleChangeExams}
                        >
                          Change Selection <ChangeCircleIcon />
                        </Button>
                      </Box>
                    </Grid>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Typography variant="body2" component="p" color="primary">
                      Once you are ready to process your entry payment online,
                      click on CheckOut and follow the online payment
                      instructions.
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <Button
                          fullWidth
                          variant="contained"
                          onClick={handleSubmit}
                        >
                          Checkout
                          <ShoppingCartCheckoutIcon />
                        </Button>
                      </Box>

                      <Box mb={5} />
                    </Grid>
                  </Box>

                  <Box mb={5} />
                </Grid>
              </>
            )}

            <Grid item xs={12}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography variant="body2" component="p" color="primary">
                  If you would like to cancel your application or process later,
                  click the cancel button.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      onClick={(e) => navigate('/cambridge')}
                    >
                      <CloseIcon /> Cancel
                    </Button>
                  </Box>

                  <Box mb={5} />
                </Grid>
              </Box>

              <Box mb={5} />
            </Grid>
          </Grid>
        </Container>
      )}
    </>
  );
}

export default ViewQuote;
